(function () {
  // ---------- Config ----------
  const SESSION_KEY = 'pickupAck'; // change to localStorage if you want it to persist across tabs/sessions

  // Warehouse selectors (plus safe fallbacks)
  const NORMAL_CHECKOUT_SELECTORS = [
    'a[href*="/checkout"]',                // links to /checkout
    'button[name="checkout"]',             // standard cart submit
    'input[name="checkout"]',              // legacy input submit
    '[data-cart-checkout]',                // Warehouse cart drawer/button
    '.cart__checkout',                     // common class on cart template
    '#CartDrawer-Checkout'                 // some Warehouse builds
  ];

  // Dynamic checkout blocks (iframes etc.) — product pages & quick views
  const DYNAMIC_SELECTORS = [
    '.shopify-payment-button',             // Shop Pay wrapper
    '.shopify-payment-button__button',     // some themes expose a direct button
    '.additional-checkout-buttons',        // “More payment options” wrapper
    'shopify-buy-it-now-button',           // custom element variant
    '#dynamic-checkout-cart',              // cart-level dynamic block (if used)
    '.quickshop .shopify-payment-button',  // Warehouse quick view modal
  ];
  // ----------------------------

  let allowCheckout = localStorage.getItem(SESSION_KEY) === '1';
  let upsellHandledThisPage = false;

  const modalRoot = document.getElementById('pickup-confirm');

  function openModal() {
    modalRoot.hidden = false;
    const confirmBtn = modalRoot.querySelector('[data-pickup-confirm]');
    if (confirmBtn) confirmBtn.focus();

    return new Promise((resolve, reject) => {
      const onConfirm = () => { cleanup(); resolve(); };
      const onCancel  = () => { cleanup(); reject();  };

      modalRoot.querySelector('[data-pickup-confirm]').addEventListener('click', onConfirm, { once:true });
      modalRoot.querySelector('[data-pickup-cancel]' ).addEventListener('click', onCancel,  { once:true });

      const backdrop = modalRoot.querySelector('.pickup-backdrop');
      backdrop.addEventListener('click', (e) => {
        if (e.target === backdrop) onCancel();
      }, { once:true });

      function onKey(e) { if (e.key === 'Escape') onCancel(); }
      document.addEventListener('keydown', onKey, { once:true });

      function cleanup() {
        modalRoot.hidden = true;
        document.removeEventListener('keydown', onKey, { once:true });
      }
    });
  }

  function markAcknowledged() {
    allowCheckout = true;
    localStorage.setItem(SESSION_KEY, '1');
    removeDynamicOverlays();
  }

  function runPreCheckoutFlow(onApproved) {
  const continueAfterUpsell = () => {
    upsellHandledThisPage = true;

    // Pickup has already been acknowledged previously.
    if (allowCheckout) {
      removeDynamicOverlays();
      onApproved();
      return;
    }

    // Otherwise show the existing pickup confirmation.
    openModal()
      .then(() => {
        markAcknowledged();
        onApproved();
      })
      .catch(() => {
        // Pickup confirmation was cancelled.
        // Keep guarding checkout buttons.
        guardDynamicBlocks();
      });
  };

  // Show our cart upsell first, if it exists on this page.
  if (
    !upsellHandledThisPage &&
    window.KgcCartUpsell &&
    typeof window.KgcCartUpsell.open === 'function'
  ) {
    window.KgcCartUpsell.open(continueAfterUpsell);
    return;
  }

  // No upsell available, or it has already been handled.
  continueAfterUpsell();
}

  // Is this click a normal checkout trigger?
  function isNormalCheckoutTrigger(target) {
    return NORMAL_CHECKOUT_SELECTORS.some(sel => target.closest(sel));
  }

  // ------ Intercept normal checkout buttons/links (cart page, cart drawer, header) ------
  document.addEventListener('click', function (e) {
    // If both steps have already been dealt with, let checkout behave normally.
    if (allowCheckout && upsellHandledThisPage) return;

    if (!isNormalCheckoutTrigger(e.target)) return;

    e.preventDefault();
    e.stopPropagation();

    // Capture the intended checkout element before opening any popups.
    const el = e.target.closest('a[href*="/checkout"], button, input');

    runPreCheckoutFlow(() => {

      // Reperform the intended action
      if (el && el.tagName === 'A') {
        const href = el.getAttribute('href') || '/checkout';
        window.location.href = href;
        return;
      }

      // Try to submit its form (cart page), else go directly
      const form = (el && el.form)
        ? el.form
        : document.querySelector('form[action="/cart"]');

      if (form) {
        if (!form.querySelector('input[name="checkout"]')) {
          const i = document.createElement('input');

          i.type = 'hidden';
          i.name = 'checkout';
          i.value = 'Checkout';

          form.appendChild(i);
        }

        form.submit();

      } else {
        window.location.href = '/checkout';
      }

    });
  }, true);

  // Enter key on cart form
  document.addEventListener('submit', function (e) {
    if (allowCheckout && upsellHandledThisPage) return;
    if (!e.target.matches('form[action="/cart"]')) return;

    e.preventDefault();

    const form = e.target;

    runPreCheckoutFlow(() => {
      form.submit();
    });

  }, true);

  // ------ Guard dynamic checkout blocks (Shop Pay / More payment options) ------
  function guardDynamicBlocks() {
    if (allowCheckout && upsellHandledThisPage) return;
    document.querySelectorAll(DYNAMIC_SELECTORS.join(',')).forEach(wrapper => {
      if (!wrapper || wrapper.dataset.pickupGuarded === '1') return;

      // make the wrapper positioned so the overlay can sit over any iframes
      const cs = getComputedStyle(wrapper);
      if (cs.position === 'static') wrapper.style.position = 'relative';

      const overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.setAttribute('aria-label', 'Confirm pickup before checkout');
      overlay.style.position = 'absolute';
      overlay.style.inset = '0';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.background = 'transparent';
      overlay.style.border = '0';
      overlay.style.cursor = 'pointer';
      overlay.style.zIndex = '5';
      overlay.dataset.pickupOverlay = '1';

      overlay.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        runPreCheckoutFlow(() => {
          removeDynamicOverlays();

          // The customer can now click the real Shop Pay /
          // dynamic checkout button normally.
        });
      });

      wrapper.appendChild(overlay);
      wrapper.dataset.pickupGuarded = '1';
    });
  }

  function removeDynamicOverlays() {
    document.querySelectorAll('[data-pickupOverlay], [data-pickup-overlay]').forEach(el => el.remove());
    document.querySelectorAll(DYNAMIC_SELECTORS.join(',')).forEach(w => { if (w) delete w.dataset.pickupGuarded; });
  }

  // Run now and on any DOM updates (Warehouse quick view, AJAX sections, etc.)
  const mo = new MutationObserver(guardDynamicBlocks);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  guardDynamicBlocks();

  // Helper for your own testing in the console:
  window.__resetPickupAck = function () {
    localStorage.removeItem(SESSION_KEY);

    allowCheckout = false;
    upsellHandledThisPage = false;

    guardDynamicBlocks();
  };
})();
